import * as Yup from 'yup';
import { reverseShape } from 'Helpers/reverse-shape';

const UploadProfileImageSchema = Yup.object().shape(
  reverseShape({
    photoData: Yup.string(),
    idImageData: Yup.string(),
  })
)

export default UploadProfileImageSchema;
